import { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router';
import { getPrefixedRoute } from 'services/theming';
import { getNavigationTarget } from 'utils/getNavigationTarget';
import { useFeatures } from './useFeatures';

const useHandleLink = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { isEnabled } = useFeatures();
  const isNavigationFlagEnabled = isEnabled('Navigation');

  const handleLink = useCallback(
    (url: string, openInNewTab = false) => {
      const target = getPrefixedRoute(url);
      const returnPath = `${location.pathname}${location.search}`.trim() || '/';

      const { path, isExternal, fullUrl } = isNavigationFlagEnabled
        ? getNavigationTarget(target)
        : {
            path: target.replace('#', ''),
            isExternal: target.startsWith('http'),
            fullUrl: target,
          };

      if (openInNewTab) {
        const urlForNewTab = isExternal ? fullUrl : `${window.location.origin}${path}`;
        window.open(urlForNewTab, '_blank', 'noopener,noreferrer');
        return;
      }

      if (isExternal) {
        window.location.href = fullUrl;
      } else {
        navigate(path, { state: { returnPath }, replace: false });
      }
    },
    [navigate, location.pathname, location.search, isNavigationFlagEnabled],
  );

  return handleLink;
};

export default useHandleLink;
